"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var logger_1 = require("./logger");
exports.Logger = logger_1.Logger;
function createLogger() {
    return new logger_1.Logger();
}
exports.createLogger = createLogger;
